module.exports = __webpack_public_path__ + "img/Down.397d714d.svg";